let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lzcLj")).then(() => parcelRequire('hv9q0'));